import { CSSProperties } from 'react';
import { Div, Title } from '@gaiads/telia-react-component-library';
import { PaddingProps } from '@gaiads/telia-react-component-library/build/types/components/Element/getPaddingClasses';

interface MessageProps {
  padding?: PaddingProps;
  style?: CSSProperties;
  text?: JSX.Element;
}

export default function Message({ padding = { top: 'xlg' }, style = { width: '100%' }, text }: MessageProps) {
  return (
    <Div alignTextToCenter padding={padding} style={style}>
      <Title size={'lg'}>{text}</Title>
    </Div>
  );
}
